import * as FrontCubeData from '../../frontCubeData/index';
import * as Utils from '../../utils/util';

// 具有叠放商品
export function hasFoldGoods(cubeId: string): boolean {
    let xPileSurfaceWidth: number = Utils.toNumber(FrontCubeData.getValue(cubeId, 'xPileSurfaceWidth'));
    let xPileSurfaceHeight: number = Utils.toNumber(FrontCubeData.getValue(cubeId, 'xPileSurfaceHeight'));
    let yPileSurfaceHeight: number = Utils.toNumber(FrontCubeData.getValue(cubeId, 'yPileSurfaceHeight'));
    let yPileSurfaceWidth: number = Utils.toNumber(FrontCubeData.getValue(cubeId, 'yPileSurfaceWidth'));

    return !!xPileSurfaceWidth || !!xPileSurfaceHeight || !!yPileSurfaceHeight || !!yPileSurfaceWidth;
}

// 商品是否具有多面宽
export function hasMoreSurface(cubeId: string): boolean {
    let surfaceWidth: number = Utils.toNumber(FrontCubeData.getValue(cubeId, 'surfaceWidth'));

    return surfaceWidth > 1;
}
